import { render, staticRenderFns } from "./SelectProductInput.vue?vue&type=template&id=3a43dbe3&scoped=true"
import script from "./SelectProductInput.vue?vue&type=script&lang=js"
export * from "./SelectProductInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43dbe3",
  null
  
)

export default component.exports